import { AppEntities } from "../../../../config/entities";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const CategoryOfFixedAssetList = () => {
  const fields = [{ title: "Name", fieldName: "name" }];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.CategoryOfFixedAsset}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default CategoryOfFixedAssetList;
